import { Command, CommandContribution, CommandRegistry } from '@theia/core';
import { KeybindingContribution, KeybindingRegistry } from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { platformApi } from '@lved/api-gateway';

export const LaunchScreenCommand: Command = {
    id: 'lvgl:project-launcher',
    label: 'Project Launcher'
};

@injectable()
export class LaunchScreenContribution implements CommandContribution, KeybindingContribution {
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(LaunchScreenCommand, {
            execute: () => {
                platformApi.sendGlobalEvent('show-launch-screen');
            }
        });
    }

    registerKeybindings(keybindings: KeybindingRegistry): void {
        keybindings.registerKeybinding({
            command: LaunchScreenCommand.id,
            keybinding: 'shift+ctrlcmd+o'
        });
    }
}
